import getContextHook from '../contexts/getContextHook';
import { MessagesDispatchContext } from '../contexts/Messages';

export default getContextHook(MessagesDispatchContext);
